import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { SvgIconComponent } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { CampaignContentState } from '../../store/models/campaign-models';
import { selectCampaignContentByKey } from '../../store/selectors/campaign.selectors';
import { ContentComponent } from '../common/content/content.component';
import { FixedContentPageComponent } from '../common/fixed-content/fixed-content.component';

@Component({
    selector: 'conclusion',
    templateUrl: './conclusion.component.html',
    styleUrl: './conclusion.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent, ContentComponent, AsyncPipe, FixedContentPageComponent]
})
export class ConclusionComponent {
  pageHeadingKey: string = 'end-page-heading';
  pageHeadingValue$: Observable<string | null>;
  pageBodyKey: string = 'end-page-body';
  pageBodyValue$: Observable<string | null>;

  constructor(private contentStore: Store<CampaignContentState>) {
    this.pageHeadingValue$ = this.contentStore.select(selectCampaignContentByKey(this.pageHeadingKey));
    this.pageBodyValue$ = this.contentStore.select(selectCampaignContentByKey(this.pageBodyKey));
  }
}
